/*
 * Mirrorpro Auto TOC Generator
 * Automatically generates a table of contents from H2 headings
 * in blog articles (only on pages with body.template-article class)
 */
(function() {
  'use strict';

  // Only run on blog article pages
  if (!document.body.classList.contains('template-article')) return;

  // Find the article content container
  var article =
    document.querySelector('article') ||
    document.querySelector('.article-template__content') ||
    document.querySelector('.article__content') ||
    document.querySelector('.rte');

  if (!article) return;

  // Find all H2 headings in the article
  var headings = article.querySelectorAll('h2');
  if (headings.length < 3) return; // Only show TOC if 3+ sections

  // Avoid duplicate TOC on re-runs
  if (document.querySelector('.cd-auto-toc')) return;

  // Create TOC container
  var toc = document.createElement('div');
  toc.className = 'cd-auto-toc';
  var tocHeader = document.createElement('h3');
  tocHeader.textContent = '📋 Inhoudsopgave';
  toc.appendChild(tocHeader);

  var tocList = document.createElement('ul');
  toc.appendChild(tocList);

  // Generate TOC entries and add anchor IDs to headings
  headings.forEach(function(heading, index) {
    // Skip FAQ and author sections
    var headingText = heading.textContent.trim();
    var lowerText = headingText.toLowerCase();
    if (lowerText.indexOf('veelgestelde vragen') !== -1) return;
    if (lowerText.indexOf('over de auteur') !== -1) return;

    // Generate ID from heading text
    var headingId = heading.id;
    if (!headingId) {
      headingId = 'cd-section-' + index + '-' + headingText
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '')
        .substring(0, 40);
      heading.id = headingId;
    }

    // Create TOC link
    var li = document.createElement('li');
    var link = document.createElement('a');
    link.href = '#' + headingId;
    link.textContent = headingText;

    // Smooth scroll on click
    link.addEventListener('click', function(e) {
      e.preventDefault();
      var target = document.getElementById(headingId);
      if (target) {
        var offsetTop = target.getBoundingClientRect().top + window.scrollY - 100;
        window.scrollTo({
          top: offsetTop,
          behavior: 'smooth'
        });
        if (history.pushState) {
          history.pushState(null, null, '#' + headingId);
        }
      }
    });

    li.appendChild(link);
    tocList.appendChild(li);
  });

  // Only insert if we actually added TOC items
  if (tocList.children.length === 0) return;

  // Insert TOC after the first paragraph (or at the top if no first paragraph)
  var firstParagraph = article.querySelector('p');
  if (firstParagraph && firstParagraph.parentNode) {
    firstParagraph.parentNode.insertBefore(toc, firstParagraph.nextSibling);
  } else {
    article.insertBefore(toc, article.firstChild);
  }
})();
